const INTL_LOCALE_MAP = {
  pt: 'pt-BR',
  en: 'en-US',
  es: 'es-ES',
};

const LANGUAGE_DEFAULT_CURRENCY = {
  pt: 'BRL',
  en: 'USD',
  es: 'EUR',
};

export const SUPPORTED_CURRENCIES = [
  { code: 'BRL', locale: 'pt-BR', label: 'Real (R$)' },
  { code: 'USD', locale: 'en-US', label: 'US Dollar ($)' },
  { code: 'EUR', locale: 'de-DE', label: 'Euro (€)' },
  { code: 'GBP', locale: 'en-GB', label: 'British Pound (£)' },
  { code: 'JPY', locale: 'ja-JP', label: 'Japanese Yen (¥)' },
  { code: 'ARS', locale: 'es-AR', label: 'Peso Argentino (AR$)' },
  { code: 'MXN', locale: 'es-MX', label: 'Peso Mexicano (MX$)' },
  { code: 'CLP', locale: 'es-CL', label: 'Peso Chileno (CLP$)' },
  { code: 'COP', locale: 'es-CO', label: 'Peso Colombiano (COL$)' },
  { code: 'PEN', locale: 'es-PE', label: 'Sol Peruano (S/)' },
  { code: 'CAD', locale: 'en-CA', label: 'Canadian Dollar (CA$)' },
  { code: 'AUD', locale: 'en-AU', label: 'Australian Dollar (A$)' },
  { code: 'CHF', locale: 'de-CH', label: 'Swiss Franc (CHF)' },
  { code: 'CNY', locale: 'zh-CN', label: 'Chinese Yuan (¥)' },
  { code: 'INR', locale: 'en-IN', label: 'Indian Rupee (₹)' },
];

const CURRENCY_LOCALE_MAP = SUPPORTED_CURRENCIES.reduce((acc, c) => {
  acc[c.code] = c.locale;
  return acc;
}, {});

export function intlLocale(lang) {
  return INTL_LOCALE_MAP[lang] || 'pt-BR';
}

export function intlCurrency(lang) {
  return LANGUAGE_DEFAULT_CURRENCY[lang] || 'BRL';
}

export function currencyLocale(currency) {
  return CURRENCY_LOCALE_MAP[currency] || 'pt-BR';
}

export function defaultCurrencyForLanguage(lang) {
  return LANGUAGE_DEFAULT_CURRENCY[lang] || 'BRL';
}

export function formatCurrency(value, currency = 'BRL') {
  const safeValue = Number.isFinite(Number(value)) ? Number(value) : 0;
  const locale = currencyLocale(currency);
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(safeValue);
}

export function getCurrencyParts(currency = 'BRL') {
  const locale = currencyLocale(currency);
  const fmt = new Intl.NumberFormat(locale, { style: 'currency', currency });
  const parts = fmt.formatToParts(1234.5);

  let symbol = '';
  let thousandSeparator = '';
  let decimalSeparator = '.';
  let decimalScale = 2;
  let prefix = '';
  let suffix = '';
  let symbolBefore = true;

  parts.forEach((p, idx) => {
    if (p.type === 'currency') {
      symbol = p.value;
      const next = parts[idx + 1];
      if (next && next.type === 'literal') {
        prefix = `${p.value}${next.value}`;
      } else {
        prefix = p.value;
      }
      symbolBefore = idx === 0 || (idx === 1 && parts[0].type === 'literal');
    }
    if (p.type === 'group') thousandSeparator = p.value;
    if (p.type === 'decimal') decimalSeparator = p.value;
    if (p.type === 'fraction') decimalScale = p.value.length;
  });

  if (!symbolBefore) {
    suffix = ` ${symbol}`;
    prefix = '';
  }

  return {
    symbol,
    prefix,
    suffix,
    thousandSeparator,
    decimalSeparator,
    decimalScale,
    symbolBefore,
  };
}
